import compo from './legoDashboard';
import cItem from './legoDashboardItem';

export default {
  install(Vue) {
    Vue.component(compo.name, compo);
    Vue.component(cItem.name, cItem);
  },
};
